import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

/* eslint jsx-a11y/label-has-associated-control: "off" */

const MailForm = () => {
	return (
		<div style={{ display: 'flex' }}>
			<section className="services">
				<div className="container">
					<div className="row pb-5 mb-5">
						<div className="col-12">
							<h1 style={{ width: '100%' }} className="u-color-secondary u-weight-smb">
								Get in touch
							</h1>
						</div>
						<div className="col-12 col-md-4 mb-5 mb-md-0 mt-5 mt-md-0">
							<aside className="contact__aside pb-md-5">
								<div className="contact__aside-intro">
									<div className="u-weight-smb mb-4">
										<h4 className="u-weight-smb mb-4">901 Sunrise Blvd Suite B10</h4>
										<h4 className="u-weight-smb mb-4">
											Roseville, CA 95661 (<a
												style={{ color: 'blue' }}
												href="https://www.google.com/search?q=901+Sunrise+Blvd+Suite+B10+Roseville%2C+CA+95661&oq=901+Sunrise+Blvd+Suite+B10+Roseville%2C+CA+95661&aqs=chrome..69i57.949j0j7&sourceid=chrome&ie=UTF-8#"
											>
												map
											</a>)
										</h4>
									</div>
								</div>
								<h2 className="h2--lg u-weight-bld u-color-black">
									<a style={{ fontSize: '2.2rem' }} href="tel:9167732020">
										(916) 773 2020
									</a>
								</h2>
								<div className="contact__info my-5">
									<div className="contact__info-group">
										<div className="contact__info-group-main">
											<h4 className="u-weight-smb mb-4">Email</h4>
											<h4 className="u-weight-smb mb-4">
												<a
													href="mailto:lanlinville (a) hotmail.com"
													style={{ whiteSpace: 'nowrap' }}
												>
													lanlinville (a) hotmail.com
												</a>
											</h4>
										</div>
									</div>
								</div>
								<h4 className="u-weight-smb mb-4" style={{ marginLeft: '1.25rem' }}>
									Follow us on Facebook
								</h4>
								<div className="contact__social mb-md-5" style={{ marginLeft: '1.25rem' }}>
									<a href="http://www.facebook.com/pages/Lan-Linville-Drafting/203152083056762">
										<FontAwesomeIcon aria-label="Facebook" icon={faFacebook} />
										&nbsp;Facebook
									</a>
								</div>
							</aside>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};
export default MailForm;
//<!-- <a href="tel:916xxxxxxx">916-xxx-xxxx</a> -->
